import React from 'react';
import { Layers, Users, MessageSquare, Database, Brain, Target } from 'lucide-react';
export function PlatformSection() {
  return <section id="challenge" className="relative bg-[#fafafa] py-32 md:py-40 px-7 md:px-40 overflow-hidden" data-id="element-72">
      {/* Subtle top gradient transition from dark hero */}
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#1a1a1a] to-transparent pointer-events-none opacity-30" data-id="element-73" />

      <div className="max-w-6xl mx-auto" data-id="element-74">
        <div className="mb-24 max-w-4xl mx-auto px-8" data-id="element-75">
          <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f] mb-4 text-left" data-id="element-76">
            The Challenge
          </p>
          <h2 className="text-4xl md:text-6xl text-[#1a1a1a] font-light leading-tight text-center" data-id="element-77">
            Distribution is a{' '}
            <span className="text-[#1e3a5f]" data-id="element-78">$T Industry</span> Stuck in the
            20th Century
          </h2>
        </div>

        {/* Overlapping Cards Container */}
        <div className="relative max-w-xl mx-auto" data-id="element-79">
          {/* First Card - Offset Left */}
          <div className="relative md:-ml-32 mb-8 md:mb-0 md:mr-64" data-id="element-80">
            <div className="bg-white border-2 border-gray-200 p-8 md:p-12 shadow-lg" data-id="element-81">
              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-8" data-id="element-82">
                The global distribution industry evolved in a world without
                data, software, or AI. Today, that creates massive
                inefficiencies:
              </p>

              <ul className="space-y-6" data-id="element-83">
                <li className="flex items-start space-x-4" data-id="element-84">
                  <div className="flex-shrink-0 w-10 h-10 bg-gray-100 flex items-center justify-center" data-id="element-85">
                    <Layers className="w-5 h-5 text-gray-600" data-id="element-86" />
                  </div>
                  <span className="text-lg text-gray-700 leading-relaxed pt-2" data-id="element-87">
                    Goods move through layers of intermediaries
                  </span>
                </li>
                <li className="flex items-start space-x-4" data-id="element-88">
                  <div className="flex-shrink-0 w-10 h-10 bg-gray-100 flex items-center justify-center" data-id="element-89">
                    <Users className="w-5 h-5 text-gray-600" data-id="element-90" />
                  </div>
                  <span className="text-lg text-gray-700 leading-relaxed pt-2" data-id="element-91">
                    Decisions are driven by relationships and heuristics
                  </span>
                </li>
                <li className="flex items-start space-x-4" data-id="element-92">
                  <div className="flex-shrink-0 w-10 h-10 bg-gray-100 flex items-center justify-center" data-id="element-93">
                    <MessageSquare className="w-5 h-5 text-gray-600" data-id="element-94" />
                  </div>
                  <span className="text-lg text-gray-700 leading-relaxed pt-2" data-id="element-95">
                    Information travels via calls, emails, PDFs, and WhatsApp
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Second Card - Offset Right, Overlapping */}
          <div className="relative md:ml-64 md:-mr-32 md:-mt-16 z-10" data-id="element-96">
            <div className="bg-gradient-to-br from-[#1e3a5f] to-[#2d5a8f] border-2 border-[#1e3a5f] p-8 md:p-12 shadow-xl text-white" data-id="element-97">
              <p className="text-xl text-white/90 font-light mb-4" data-id="element-98">
                This model worked when supply and demand were opaque.
              </p>
              <p className="text-2xl md:text-3xl font-semibold mb-8" data-id="element-99">
                But now:
              </p>

              <div className="space-y-6" data-id="element-100">
                <div className="flex items-start space-x-4" data-id="element-101">
                  <div className="flex-shrink-0 w-10 h-10 bg-white/20 flex items-center justify-center" data-id="element-102">
                    <Database className="w-5 h-5 text-white" data-id="element-103" />
                  </div>
                  <p className="text-lg md:text-xl leading-relaxed pt-2" data-id="element-104">
                    Data makes demand measurable
                  </p>
                </div>

                <div className="flex items-start space-x-4" data-id="element-105">
                  <div className="flex-shrink-0 w-10 h-10 bg-white/20 flex items-center justify-center" data-id="element-106">
                    <Brain className="w-5 h-5 text-white" data-id="element-107" />
                  </div>
                  <p className="text-lg md:text-xl leading-relaxed pt-2" data-id="element-108">
                    AI turns fragmented supply into structured data
                  </p>
                </div>

                <div className="flex items-start space-x-4" data-id="element-109">
                  <div className="flex-shrink-0 w-10 h-10 bg-white/20 flex items-center justify-center" data-id="element-110">
                    <Target className="w-5 h-5 text-white" data-id="element-111" />
                  </div>
                  <p className="text-lg md:text-xl leading-relaxed pt-2" data-id="element-112">
                    AI can surface the exact products that retailers want
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}